import React, { useEffect } from "react";
import PublicLayout from "web/components/PublicLayout";
import WsjLogo from "../../../../../assets/images/NewsRoomImages/WSJ_Logo.svg.png";
import headCutPaul from "../../../../../assets/images/NewsRoomImages/hedcut-paul.png";
import shipImage from "../../../../../assets/images/NewsRoomImages/ship-image-croped.jpeg";

import LandingFooter from "web/pages/public/landing-page/LandingFooter";
import AOS from "aos";

import {
  Container,
  Wrapper,
  Box,
  Box2,
  Box3,
} from "web/pages/public/landing-page/NewsRoom/WsjLink/WsjLinkStyled";

const WsjLink = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 320,
    });
  }, []);
  return (
    <PublicLayout transparentHeader={true}>
      <Container>
        <Wrapper>
          <Box>
            <img src={WsjLogo} alt="wsj-logo" />
            <p>Oct 21, 2022</p>
          </Box>
          <Box2>
            <h4>LOGISTICS REPORT</h4>
            <div className="report-container">
              <img src={headCutPaul} alt="man-cap" className="headcut-image" />
              <div>
                <p className="main-sub">
                  California's Ship Backup Fades; Tankers are Waiting;
                  Railroads' Pricing Power
                </p>
                <p className="reporter">
                  <i>By Paul Page</i>
                </p>
              </div>
            </div>
            <hr />
            <img src={shipImage} alt="ship-image" className="ship-img" />
          </Box2>
          <Box3>
            <hr />
            <h4>In Other News</h4>
            <p>
              Startup Bettaway Supply Chain Services launched an{" "}
              <a
                href="https://www.dcvelocity.com/articles/55795-pallet-trading-website-would-bring-digital-platform-to-outdated-market?mod=djemlogistics_h"
                target="_blank" 
                rel="noopener noreferrer"
              >
                online
                {/* <br /> */} pallet-trading marketplace
              </a>{" "}
              in the U.S. (DC Velocity)
            </p>
          </Box3>
        </Wrapper>
      </Container>
      <LandingFooter />
    </PublicLayout>
  );
};

export default WsjLink;
